module.exports = __webpack_public_path__ + "static/media/avatar-regina.57880c0d.png";